import json from '$lib/assets/data/languages.json';
import type { Language } from '$lib/features/country/language/language.type';

export class LanguageService {
    private static ALL_LANGUAGES: Language[] = (json as Language[]);

    public getAllLanguages(): Language[] {
        return LanguageService.ALL_LANGUAGES;
    }

    public static getByCode(code: string): Language {
        const foundLanguage = LanguageService.ALL_LANGUAGES.find((item) => item.code.toLowerCase() === code.toLowerCase());
        if (foundLanguage === undefined) throw new Error(`Language with code ${code} not found`);
        return foundLanguage;
    }
}